import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .Dropdown-root {
    position: relative;
  }

  .Dropdown-control {
    position: relative;
    box-sizing: border-box;
    cursor: default;
    outline: none;
    transition: all 200ms ease;
    line-height: 1.1;
    min-width: 65px;

    text-align: center;
    cursor: pointer;
  }

  .Dropdown-arrow {
    position: absolute;
    top: 45%; right: 5px;

    width: 0;
    height: 0;

    border-style: solid;
    border-width: 5px 4px 0 4px;
    border-color: #ffffff transparent transparent transparent;

    transform: translate3d(0, -50%, 0);
  }

  .Dropdown-menu {
    position: absolute;
    top: -14px; left: 5px;

    width: 100%;
    max-height: 200px;

    padding: 5px;

    background-color: white;
    box-sizing: border-box;

    overflow-y: auto;

    z-index: 1000;
    -webkit-overflow-scrolling: touch;
  }

  .Dropdown-menu .Dropdown-group > .Dropdown-title{
    padding: 8px 10px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    text-transform: capitalize;
  }

  .Dropdown-option {
    position: relative;
    color: #5E5E5E;
    opacity: 0.5;

    padding: 10px 13px;

    transition: opacity .2s ease-in-out;
    cursor: pointer;
  }

  .Dropdown-option:hover, .Dropdown-option.is-selected {
    opacity: 1;
  }

  .Dropdown-option.is-selected {
    pointer-events: none;
  }

  .Dropdown-option.is-selected:after {
    content: '';

    position: absolute;
    top: 10px; right: 5px;

    width: 0;
    height: 0;

    border-style: solid;
    border-width: 0 4px 5px 4px;
    border-color: transparent transparent #FB5237 transparent;
  }

  .Dropdown-noresults {
    box-sizing: border-box;
    color: #ccc;
    cursor: default;
    display: block;
    padding: 8px 10px;
  }
`;

export const Root = styled.div`
  display: flex;
  flex-direction: row;

  .Dropdown-root {
    padding: 0 ${props => props.theme.layout.gutter / 2}px;

    font-family: ${props => props.theme.font.brand.primary};
    font-size: 13px;
    line-height: 30px;

    width: auto;
    min-width: 145px;
    max-height: 30px;
    background-color: #f3f5f7;

    color: ${props => props.theme.color.brand.grey};

    border: none;

    &.is-open {
      max-height: 200px;

      .Dropdown-arrow {
        transform: rotate(-180deg);
      }
    }
  }

  .Dropdown-control {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    justify-content: space-between;
  }

  .Dropdown-placeholder {
    line-height: 30px;
  }

  .Dropdown-arrow {
    position: absolute;
    right: 0;
    top: 40%;
    transform: none;

    margin-left: ${props => props.theme.layout.gutter / 2}px;

    border-color: ${props => props.theme.color.brand.accent} transparent
      transparent transparent;

    transition: transform 200ms ease-in-out;
  }

  .Dropdown-menu {
    position: relative;
    top: auto;
    left: auto;
    background-color: #f3f5f7;

    padding: 0;
  }

  .Dropdown-option {
    padding: 0;
    line-height: 30px;

    &.is-selected:after {
      content: none;
    }
  }
`;

export const Label = styled.p`
  font-family: ${props => props.theme.font.brand.secondary};
  font-size: 13px;
  line-height: 28px;

  margin-right: ${props => props.theme.layout.gutter / 2}px;

  color: ${props => props.theme.color.brand.primary};
`;
